import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { motion } from "framer-motion";

const schema = yup
    .object({
        name: yup
            .string()
            .trim()
            .min(2, "Nom trop court")
            .max(100, "Nom trop long")
            .required("Nom requis"),
        email: yup
            .string()
            .trim()
            .email("Email invalide")
            .max(254, "Email trop long")
            .required("Email requis"),
        message: yup
            .string()
            .trim()
            .min(10, "Message trop court")
            .max(2000, "Message trop long")
            .required("Message requis"),
    })
    .required();

const Estimate = () => {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
        reset,
        setError,
    } = useForm({ resolver: yupResolver(schema) });

    const onSubmit = async (data) => {
        try {
            const res = await fetch("/contact", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: data.name.trim(),
                    email: data.email.trim(),
                    message: data.message.trim(),
                }),
            });

            const payload = await res.json().catch(() => null);

            if (!res.ok) {
                setError("root", {
                    type: "server",
                    message: payload?.error || "Erreur d’envoi",
                });
                return;
            }

            reset();
        } catch (err) {
            setError("root", {
                type: "network",
                message: "Impossible d’envoyer le message pour le moment.",
            });
        }
    };

    return (
        <section id="devis" className="bg-light-backgroundAlt dark:bg-dark-backgroundAlt p-6 h-full">
            <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-5 pb-5">
                Demandez votre devis à un électricien à Nancy
            </h2>

            <p className="text-center text-light-text dark:text-dark-text max-w-3xl mx-auto px-4">
                Décrivez votre projet : dépannage, installation électrique, borne IRVE, domotique, portail, interphonie ou panneaux solaires. Réponse rapide.
            </p>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="max-w-md mx-auto mt-10 bg-white shadow-lg rounded-2xl p-6"
            >
                <h3 className="text-2xl font-semibold mb-4 text-gray-800">Demande de devis</h3>

                {isSubmitSuccessful && (
                    <p className="text-green-600 mb-4">✅ Message envoyé avec succès !</p>
                )}

                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    <div className="mb-4">
                        <label className="block mb-1 font-medium text-gray-700">Nom</label>
                        <input
                            type="text"
                            placeholder="Ex : John DOE"
                            maxLength={100}
                            autoComplete="name"
                            {...register("name")}
                            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.name && <p className="text-red-500 text-sm">{errors.name.message}</p>}
                    </div>

                    <div className="mb-4">
                        <label className="block mb-1 font-medium text-gray-700">Email</label>
                        <input
                            type="email"
                            placeholder="Ex : john.doe@outlook.com"
                            maxLength={254}
                            autoComplete="email"
                            {...register("email")}
                            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
                    </div>

                    <div className="mb-4">
                        <label className="block mb-1 font-medium text-gray-700">Message</label>
                        <textarea
                            {...register("message")}
                            placeholder="Ex : Bonjour, je souhaiterais un devis pour..."
                            maxLength={2000}
                            className="w-full p-2 border rounded-md h-28 focus:ring-2 focus:ring-blue-500"
                        />
                        {errors.message && <p className="text-red-500 text-sm">{errors.message.message}</p>}
                    </div>

                    {errors.root && (
                        <p className="text-red-600 text-sm mb-4">{errors.root.message}</p>
                    )}

                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition disabled:opacity-50"
                    >
                        {isSubmitting ? "Envoi..." : "Envoyer"}
                    </button>
                </form>
            </motion.div>
        </section>
    );
};

export default Estimate;